import Enumerable from "linq";
import { Command, HttpMethod } from "~/extensions/api";
export class DeleteFile extends Command {
    constructor(model) {
        super(HttpMethod.Post, "taikyonotification/file/delete");
        this.delFileList = Enumerable.from(model.taikyoList)
            .select(x => new DeleteFileInfo(x))
            .toArray();
    }
    /** 削除ファイル情報リスト */
    delFileList = [];
}
export class DeleteFileInfo {
    constructor(model) {
        this.orgNyukyokeiyakuNo = model.taikyoNo;
        this.attachedFiles = Enumerable.from(model.fileList)
            .select(x => new AttachedFileInfo(x))
            .toArray();
    }
    /** オリジナル入居契約No. */
    orgNyukyokeiyakuNo = -1;
    /** 添付ファイルリスト*/
    attachedFiles = [];
}
export class AttachedFileInfo {
    constructor(model) {
        this.fileId = model.fileId;
        this.delFlg = model.delFlg;
    }
    /** ファイルID */
    fileId = "";
    /** 削除フラグ */
    delFlg = false;
}
